import { FormField } from "./eFormFieldTypes";

interface IComponentField {
    key: string;
    label: string;
    required?: boolean;
    value: string | string[] | boolean | object[];
    type: FormField;
    case?: string;
    copyTo?: string;
    copyCase?: string;
    /** Logical group in the collection settings editor */
    section?: string;
    /** Helper text shown under the control */
    hint?: string;
}

export enum role {
    user = 'user',
    admin = 'admin'
}
export enum owner {
    public = 'public',
    user = 'user',
    group = 'group'
}

export enum Epublic {
    public = 'public',
    managed = 'managed',
    unlisted = 'unlisted',
    private = 'private'
}


export interface IComponent {
    uid: string,
    name: string,
    slug: string,
    collection?: string,
    fields: IComponentField[],
    showGroups: boolean,
    user?: string,
    public?: string,
    dataSource?: 'mongodb',
    mongoCollection?: string,
    /** Optional organization label for tenant scoping and UI filtering. */
    organization?: string,
    /** Optional folder label used to group this collection in the left menu. */
    menuFolder?: string,
    /** Optional Phosphor filled icon export name for the left menu (e.g. PiHouseFill). */
    menuIcon?: string,
    created?: string,
    updated?: string
}

/** Section headers for the collection settings form (EditComponent) */
export const collectionSettingsSectionMeta: Record<string, { title: string; description?: string }> = {
    identity: {
        title: 'Identity',
        description: 'Display name and URL slug used to identify this collection.',
    },
    organization: {
        title: 'Organization',
        description:
            'Optional. Choose a registered organization (same list as Admin → Users). Use ACL group rules to grant manager access for that tenant/collection.',
    },
    visibility: {
        title: 'Visibility and layout',
        description: 'UI layout controls for this collection. Public exposure is now managed with ACL actions.',
    },
    storage: {
        title: 'Storage',
        description: 'MongoDB collection name used for items. Renaming can break links to existing data—coordinate with an administrator.',
    },
    fields: {
        title: 'Fields',
        description: 'Define columns and form inputs for each item.',
    },
};

export const componentDef: IComponentField[] = [
    {
        key: 'name',
        label: 'Name',
        required: true,
        value: '',
        type: FormField.Text,
        case: 'title',
        copyTo: 'slug',
        copyCase: 'lower',
        section: 'identity',
    },
    {
        key: 'slug',
        label: 'Slug',
        required: true,
        value: '',
        type: FormField.Text,
        case: 'lower',
        section: 'identity',
        hint: 'Lowercase letters, numbers, and underscores work best. Changing the slug affects existing bookmarks.',
    },
    {
        key: 'organization',
        label: 'Organization',
        required: false,
        value: '',
        type: FormField.TenantSelect,
        section: 'organization',
        hint: 'Choose a registered organization to scope tenant data. Leave unset for collections shared across tenants.',
    },
    {
        key: 'showGroups',
        label: 'Show groups',
        type: FormField.Checkbox,
        value: true,
        section: 'visibility',
    },
    {
        key: 'menuFolder',
        label: 'Menu folder',
        type: FormField.Text,
        value: '',
        required: false,
        section: 'visibility',
        hint: 'Optional. Group this collection under a folder in the left menu (for example: Sales or Operations).',
    },
    {
        key: 'menuIcon',
        label: 'Menu icon',
        type: FormField.MenuIcon,
        value: '',
        required: false,
        section: 'visibility',
        hint: 'Optional. Pick a filled Phosphor icon for this collection in the left menu.',
    },
    {
        key: 'mongoCollection',
        label: 'MongoDB Collection',
        type: FormField.Text,
        value: '',
        required: false,
        section: 'storage',
    },
    {
        key: 'fields',
        label: 'Fields',
        type: FormField.ArrayOfFields,
        value: [],
        section: 'fields',
    },
];
